import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import SnackStore from '../../stores/SnackStore';
import UDPoliciesStore from '../../stores/UDPolicies/UDPoliciesStore';
import { ConsoleCheckbox } from '../ConsoleFragments';
import ConsoleModal from '../ConsoleModal/ConsoleModal';
import Button from '../Button';
import './DeleteUDPolicyModal.css';

const block = b.lock('DeleteUDPolicyModal');

class DeleteUDPolicyModal extends Component {
    static propTypes = {
        udPolicies: UDPoliciesStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    onSubmit = (event) => {
        event.preventDefault();
        this.props.udPolicies.deletePolicy()
            .then((p) => this.props.snack.showSuccess(`Policy “${p.name}” has been deleted`))
            .catch((error) => this.props.snack.showError(`Failed to delete policy. ${error.message}`));
    };

    render() {
        const { udPolicies } = this.props;
        return <ConsoleModal
            isOpen={udPolicies.deleteModal.isOpen}
            onClose={udPolicies.deleteModal.close}
            title="Delete Policy"
            headerActions={<Button
                className={block('Delete')}
                raised
                red
                onClick={this.onSubmit}
                loading={udPolicies.deleteStatus.isLoading}
                disabled={!udPolicies.deleteConfirmation.isTrue}
                style={{ minWidth: 100 }}
            >DELETE</Button>}
        >
            <div className={block('Field')}>
                <div className={block('FieldLabel')}>Policy Name</div>
                <div className={block('FieldValue')}>{udPolicies.editStore.name}</div>
            </div>
            <div style={{ marginBottom: 20 }}>
                <strong>CAUTION</strong> - Deleted policies cannot be restored.
            </div>
            <ConsoleCheckbox
                className={block('Confirm')}
                flagStore={udPolicies.deleteConfirmation}
            >Confirm the deletion of this policy</ConsoleCheckbox>
        </ConsoleModal>;
    }
}

export default inject('udPolicies', 'snack')(observer(DeleteUDPolicyModal));

